module.exports = __webpack_public_path__ + "static/media/get-recommendations-desktop-es.d603d9dc.webp";